import React, { Component } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import { LoginForm, StorageHandler } from 'C4';

import Logo from 'assets/images/logo/logo.png';
import LogoFR from 'assets/images/logo/logo-fr.png';

import CompanyLogo from 'assets/images/companylogo.png';
import { googleStore, appleStore } from 'settings';
import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';
import { storageKeys } from 'settings';


const MobileButtons = () => (
  <div className="button__container">
    <div className="buttons small">
      <a href={appleStore} target="_blank" rel="noopener noreferrer">
        <img src={apple} alt="App store" />
      </a>
      <a href={googleStore} rel="noopener noreferrer">
        <img src={google} alt="Google Play" />
      </a>
    </div>
  </div>
);

class LoginView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      language: 'en',
    };
  }

  componentDidMount() {
    this.setLanguage();
    this.addTracker();
  }
  
  setLanguage() {
    StorageHandler.load(storageKeys.lang).then((lang) => {
      this.setState({ language: lang.langFile });
    });
  }

  addTracker() {
    // Event snippet for 2022 - US - Campaign Specialist Program - Pageview on https://www.canadaspecialistprogram.com/login: Please do not remove.
    if (window.location.hostname === 'canadaspecialistprogram.us' || window.location.hostname === 'www.canadaspecialistprogram.us'
    || window.location.hostname === 'canadaspecialist.us ' || window.location.hostname === 'www.canadaspecialist.us'
    || window.location.hostname === 'canadaspecialistprogram.com' || window.location.hostname === 'www.canadaspecialistprogram.com' 
    || window.location.hostname === 'canadaspecialist.com' || window.location.hostname === 'www.canadaspecialist.com' || window.location.hostname === 'localhost') { 
      window.gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-6628166/csp/2022-0+standard',
        event_category: 'access',
        event_label: 'login'
      });
    }
  }
  
  render() {
    const { language } = this.state;
    return (
      <div className="loginView">
      <div className="loginView__bg">
        <div className="loginView__bg--content">
          <div className="buttonWrapper">
            <MobileButtons />
          </div>
          <img src={CompanyLogo} alt="Company Logo" className="logoRight" />
        </div>
      </div>
      <div className="loginView__content">
        {language !== 'fr' && <img src={Logo} className="loginView__content--logo" alt="Logo" />}
        {language === 'fr' && <img src={LogoFR} className="loginView__content--logo" alt="Logo" />}
        <LoginForm path={this.props.match.path} />
      </div>
    </div>);
  }

}

export default LoginView;

LoginView.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
};

LoginView.defaultProps = {
  match: {
    path: '/login',
  },
};
